import { render, staticRenderFns } from "./CartEvents.vue?vue&type=template&id=3ac8ff8e&"
import script from "./CartEvents.vue?vue&type=script&lang=js&"
export * from "./CartEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports